"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stage = void 0;
var Stage;
(function (Stage) {
    Stage["alpha"] = "alpha";
    Stage["beta"] = "beta";
    Stage["dev"] = "dev";
    Stage["localdev"] = "localdev";
    Stage["prod"] = "prod";
    Stage["qa"] = "qa";
    Stage["sandbox"] = "sandbox";
    Stage["staging"] = "staging";
    Stage["test"] = "test";
})(Stage = exports.Stage || (exports.Stage = {}));
//# sourceMappingURL=stage.js.map